module.exports = __webpack_public_path__ + "static/flying_fish-01f571146f936dc10fb4406fc349c1c1.png";